/* ============================================================================
   Curated First Product — GFTG port for BuildMyPOD - Hobbies v1.1.5 (Horizon)
   ----------------------------------------------------------------------------
   Pins the ad-clicked product to slot 1 of the collection grid.
   Lineage: Den Liu 12-25-25 guide -> Aleksandar Vladimirov v2 (Symmetry) -> this.
   Design notes in pages/gftg-dynamic-collection-pinning.md.

   URL contract (set in Meta catalog deep-link override):
     /collections/<coll>?first=<handle | encoded product URL>

   Behaviour:
   - No `first=` param: script no-ops (and ideally isn't even loaded — the
     loader line below is wrapped in a Liquid `request` check? No: Liquid can't
     see query params. The script is tiny and exits on line 2; acceptable.)
   - Product already in the rendered grid: pure DOM move to slot 1. No fetch.
   - Not in grid: fetch the SEARCH page's grid section (Section Rendering API)
     which renders pixel-identical product cards, extract this product's <li>,
     prepend it. One GET, force-cache.

   Loader (add to sections/main-collection.liquid, just above the final
   closing of the section, in the DUPLICATE theme):
     <script src="{{ 'curated-first-gftg.js' | asset_url }}" defer="defer"></script>

   ponytail: SEARCH_SECTION_ID is the search template's section instance id —
   it CHANGES when the theme is duplicated. After duplicating, re-read it:
     curl -s "https://good4thegame.com/search?q=x" (against the preview URL)
     | grep -o 'shopify-section-template--[0-9]*__main'
   and update the constant. Upgrade path: resolve it at runtime from a fetch of
   /search?q=… full page (extra weight; not worth it for our own single store).
============================================================================ */

(() => {
  const params = new URLSearchParams(window.location.search);
  const rawFirst = (params.get('first') || '').trim();
  if (!rawFirst) return;

  // Duplicate theme 188891103534's search-grid section (live theme's was
  // template--26703884648750__main — this id changes per theme; re-read on any
  // future duplicate via the header command).
  const SEARCH_SECTION_ID = 'template--27439384953134__main';

  const grid = document.querySelector('ul.product-grid');
  if (!grid) return;

  function handleFrom(value) {
    // Accepts a bare handle, a /products/... path, or a full (encoded) URL.
    try {
      const path = value.startsWith('http') ? new URL(value).pathname : value.split('?')[0];
      const parts = path.split('/').filter(Boolean);
      const i = parts.indexOf('products');
      if (i !== -1 && parts[i + 1]) return parts[i + 1];
      return parts.length === 1 ? parts[0] : '';
    } catch {
      return '';
    }
  }

  const handle = handleFrom(rawFirst);
  if (!handle) return;

  function findCard(root) {
    const link = root.querySelector(`li.product-grid__item a[href*="/products/${CSS.escape(handle)}"]`);
    return link ? link.closest('li.product-grid__item') : null;
  }

  function eagerImages(li) {
    li.querySelectorAll('img').forEach((img) => {
      img.loading = 'eager';
      img.setAttribute('fetchpriority', 'high');
    });
  }

  async function fetchCard() {
    // The search page renders the same product-grid cards as collections.
    // `handle:` field query returns exactly this product (verified 08-12:
    // 1 item / 100kb vs 24 items / 766kb for a words query).
    const url = `/search?q=${encodeURIComponent('handle:' + handle)}&type=product&section_id=${SEARCH_SECTION_ID}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) return null;
    const tpl = document.createElement('template');
    tpl.innerHTML = (await res.text()).trim();
    return findCard(tpl.content);
  }

  async function pin() {
    const existing = findCard(grid);
    if (existing) {
      if (existing !== grid.firstElementChild) grid.prepend(existing);
      eagerImages(existing);
      return;
    }
    const fetched = await fetchCard();
    if (!fetched) return; // product not findable: leave the grid untouched
    eagerImages(fetched);
    grid.prepend(fetched);
  }

  pin().catch(() => {});
})();
